import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import StudentLogInRoute from './routes/StudentLogInForm';

const LazyLogInLayout = React.lazy(
	() =>
		import(
			/* webpackChunkName: 'LogInLayout' */ '@routes/LogIn/components/LogInLayout'
		)
);

const LazyLogInForm = React.lazy(
	() =>
		import(
			/* webpackChunkName: 'LogInForm' */ '@routes/LogIn/components/LogInForm'
		)
);

const LazyValidateOtpForm = React.lazy(
	() =>
		import(
			/* webpackChunkName: 'ValidateOtpForm' */ '@routes/LogIn/components/ValidateOtpForm'
		)
);

export default () => {
	return {
		path: '/logIn',
		element: <AsyncLoading component={<LazyLogInLayout />} />,
		children: [
			{
				index: true,
				element: <AsyncLoading component={<LazyLogInForm />} />,
			},
			{
				path: 'validate-otp',
				element: <AsyncLoading component={<LazyValidateOtpForm />} />,
			},
			StudentLogInRoute(),
		],
	};
};
